(function() {
  'use strict';

  /* ========================================================================
     Modular Sofa Configurator — Shared engine for Mellow + Bulky
     Reads config from window.__MODULAR_CONFIGURATOR__[sectionId]
     ======================================================================== */

  /* ---------- Config Registry ---------- */

  var CONFIGS = {

    /* ---- Mellow ---- */
    'mellow': {
      name: 'Mellow Modular Sofa',
      colorHex: {
        'Off White Eco': '#e8dfd0'
      },
      colorCategories: [
        { label: 'Fabric', colors: ['Off White Eco'] }
      ],
      moduleDimensions: {
        'End Seater Left':  { w: 38.6, d: 40.6, h: 30 },
        'End Seater Right': { w: 38.6, d: 40.6, h: 30 },
        '1 Seater':         { w: 33.5, d: 40.6, h: 30 },
        'Corner':           { w: 40.6, d: 40.6, h: 30 },
        'Ottoman':          { w: 33.5, d: 27.6, h: 17 }
      },
      moduleDimensionsCm: {
        'End Seater Left':  { w: 98,  d: 103, h: 76 },
        'End Seater Right': { w: 98,  d: 103, h: 76 },
        '1 Seater':         { w: 85,  d: 103, h: 76 },
        'Corner':           { w: 103, d: 103, h: 76 },
        'Ottoman':          { w: 85,  d: 70,  h: 43 }
      },
      presets: [
        {
          id: 'mellow-3-sect',
          name: '3-Seat Sectional',
          modules: ['End Seater Left', '1 Seater', 'Corner'],
          shapeKey: 'mellow-l-3',
          setProductKey: 'mellow-3-seat-sectional',
          hasOrientation: true
        },
        {
          id: 'mellow-3-foot',
          name: '3-Seat Sofa with Ottoman',
          modules: ['End Seater Left', '1 Seater', 'End Seater Right', 'Ottoman'],
          shapeKey: 'mellow-straight-foot',
          setProductKey: 'mellow-3-seat-sofa-with-footstool',
          hasOrientation: true
        },
        {
          id: 'mellow-4-piece',
          name: '4-Piece Open-Ended Sectional',
          modules: ['End Seater Left', '1 Seater', '1 Seater', 'Corner'],
          shapeKey: 'mellow-l-4-open',
          setProductKey: 'mellow-4-piece-sectional',
          hasOrientation: true
        },
        {
          id: 'mellow-mod-sect',
          name: 'Modular Sectional',
          modules: ['End Seater Left', '1 Seater', 'Corner', 'Ottoman'],
          shapeKey: 'mellow-l-3-foot',
          setProductKey: 'mellow-modular-sectional',
          hasOrientation: true
        },
        {
          id: 'mellow-5-foot',
          name: '5-Piece with Ottoman',
          modules: ['End Seater Left', '1 Seater', '1 Seater', 'Corner', 'Ottoman'],
          shapeKey: 'mellow-l-4-open-foot',
          setProductKey: 'mellow-5-piece-sectional',
          hasOrientation: true
        }
      ],
      shapeDefs: {
        'mellow-l-3': {
          rects: [
            { x: 0, y: 0, w: 58, h: 55 },
            { x: 60, y: 0, w: 48, h: 55 },
            { x: 60, y: 57, w: 55, h: 55 }
          ],
          vw: 115, vh: 112
        },
        'mellow-straight-foot': {
          rects: [
            { x: 0, y: 0, w: 58, h: 55 },
            { x: 60, y: 0, w: 48, h: 55 },
            { x: 110, y: 0, w: 58, h: 55 },
            { x: 110, y: 63, w: 45, h: 32, isFootstool: true }
          ],
          vw: 168, vh: 95
        },
        'mellow-l-4-open': {
          rects: [
            { x: 0, y: 0, w: 58, h: 55 },
            { x: 60, y: 0, w: 48, h: 55 },
            { x: 110, y: 0, w: 48, h: 55 },
            { x: 110, y: 57, w: 55, h: 55 }
          ],
          vw: 165, vh: 112
        },
        'mellow-l-3-foot': {
          rects: [
            { x: 0, y: 0, w: 58, h: 55 },
            { x: 60, y: 0, w: 48, h: 55 },
            { x: 60, y: 57, w: 55, h: 55 },
            { x: 60, y: 120, w: 45, h: 32, isFootstool: true }
          ],
          vw: 115, vh: 152
        },
        'mellow-l-4-open-foot': {
          rects: [
            { x: 0, y: 0, w: 58, h: 55 },
            { x: 60, y: 0, w: 48, h: 55 },
            { x: 110, y: 0, w: 48, h: 55 },
            { x: 110, y: 57, w: 55, h: 55 },
            { x: 110, y: 120, w: 45, h: 32, isFootstool: true }
          ],
          vw: 165, vh: 152
        }
      },
      customModules: [
        { type: 'End Seater Left',  label: 'End Seater L',  isCorner: false, isFootstool: false, isEnd: true },
        { type: 'End Seater Right', label: 'End Seater R',  isCorner: false, isFootstool: false, isEnd: true },
        { type: '1 Seater',         label: '1 Seater',      isCorner: false, isFootstool: false },
        { type: 'Corner',           label: 'Corner',        isCorner: true,  isFootstool: false },
        { type: 'Ottoman',          label: 'Ottoman',       isCorner: false, isFootstool: true }
      ],
      hasCornerTypeToggle: false,
      hasOrientationToggle: true,
      singleColor: true
    },

    /* ---- Bulky ---- */
    'bulky': {
      name: 'Bulky Modular Sofa',
      colorHex: {
        'Light Sepia': '#c4b5a0'
      },
      colorCategories: [
        { label: 'Fabric', colors: ['Light Sepia'] }
      ],
      moduleDimensions: {
        'End Seater Left':       { w: 36,   d: 38.5, h: 30 },
        'End Seater Right':      { w: 36,   d: 38.5, h: 30 },
        '1 Seater':              { w: 32.5, d: 38.5, h: 30 },
        '45\u00b0 Round Corner': { w: 40,   d: 38,   h: 30 },
        '90\u00b0 Round Corner': { w: 53,   d: 53,   h: 30 },
        'Footstool':             { w: 31.5, d: 23.5, h: 17 },
        'Semi-Circle Footstool': { w: 37.5, d: 37.5, h: 17 }
      },
      moduleDimensionsCm: {
        'End Seater Left':       { w: 91,  d: 98,  h: 76 },
        'End Seater Right':      { w: 91,  d: 98,  h: 76 },
        '1 Seater':              { w: 83,  d: 98,  h: 76 },
        '45\u00b0 Round Corner': { w: 102, d: 97,  h: 76 },
        '90\u00b0 Round Corner': { w: 135, d: 135, h: 76 },
        'Footstool':             { w: 80,  d: 60,  h: 43 },
        'Semi-Circle Footstool': { w: 95,  d: 95,  h: 43 }
      },
      presets: [
        {
          id: 'bulky-3-seat',
          name: '3-Seat Sofa',
          modules: ['End Seater Left', '1 Seater', 'End Seater Right'],
          shapeKey: 'bulky-straight-3',
          setProductKey: 'bulky-3-seat-sofa',
          hasOrientation: false
        },
        {
          id: 'bulky-2-sect',
          name: '2-Seat Sectional',
          modules: ['End Seater Left', 'End Seater Right', 'Footstool'],
          shapeKey: 'bulky-straight-2-foot',
          setProductKey: 'bulky-2-seat-sectional',
          hasOrientation: true
        },
        {
          id: 'bulky-2-semi',
          name: '2-Seat Semi-Circle',
          modules: ['End Seater Left', 'End Seater Right', 'Semi-Circle Footstool'],
          shapeKey: 'bulky-straight-2-semi',
          setProductKey: 'bulky-2-seat-semi-circle-sectional',
          hasOrientation: true
        },
        {
          id: 'bulky-chaise',
          name: 'Sectional with Chaise',
          modules: ['End Seater Left', '1 Seater', 'End Seater Right', 'Footstool'],
          shapeKey: 'bulky-straight-3-foot',
          setProductKey: 'bulky-sectional-with-chaise',
          hasOrientation: true
        },
        {
          id: 'bulky-semi-chaise',
          name: 'Semi-Circle Chaise',
          modules: ['End Seater Left', '1 Seater', 'End Seater Right', 'Semi-Circle Footstool'],
          shapeKey: 'bulky-straight-3-semi',
          setProductKey: 'bulky-sectional-semi-circle-chaise',
          hasOrientation: true
        },
        {
          id: 'bulky-round-sect',
          name: 'Round Corner Sectional',
          modules: ['End Seater Left', '1 Seater', '90\u00b0 Round Corner', '1 Seater'],
          shapeKey: 'bulky-l-90-open',
          setProductKey: 'bulky-round-corner-sectional',
          hasOrientation: true
        },
        {
          id: 'bulky-round-foot',
          name: 'Corner + Footstool',
          modules: ['End Seater Left', '1 Seater', '90\u00b0 Round Corner', '1 Seater', 'Footstool'],
          shapeKey: 'bulky-l-90-open-foot',
          setProductKey: 'bulky-corner-sofa-with-footstool',
          hasOrientation: true
        },
        {
          id: 'bulky-round-semi',
          name: 'Corner + Semi-Circle',
          modules: ['End Seater Left', '1 Seater', '90\u00b0 Round Corner', '1 Seater', 'Semi-Circle Footstool'],
          shapeKey: 'bulky-l-90-open-semi',
          setProductKey: 'bulky-corner-sofa-with-semi-circle',
          hasOrientation: true
        }
      ],
      shapeDefs: {
        'bulky-straight-3': {
          rects: [
            { x: 0, y: 0, w: 56, h: 55 },
            { x: 58, y: 0, w: 48, h: 55 },
            { x: 108, y: 0, w: 56, h: 55 }
          ],
          vw: 164, vh: 55
        },
        'bulky-straight-2-foot': {
          rects: [
            { x: 0, y: 0, w: 56, h: 55 },
            { x: 58, y: 0, w: 56, h: 55 },
            { x: 58, y: 63, w: 42, h: 30, isFootstool: true }
          ],
          vw: 114, vh: 93
        },
        'bulky-straight-2-semi': {
          rects: [
            { x: 0, y: 0, w: 56, h: 55 },
            { x: 58, y: 0, w: 56, h: 55 },
            { x: 58, y: 63, w: 50, h: 28, isSemiCircle: true }
          ],
          vw: 114, vh: 91
        },
        'bulky-straight-3-foot': {
          rects: [
            { x: 0, y: 0, w: 56, h: 55 },
            { x: 58, y: 0, w: 48, h: 55 },
            { x: 108, y: 0, w: 56, h: 55 },
            { x: 108, y: 63, w: 42, h: 30, isFootstool: true }
          ],
          vw: 164, vh: 93
        },
        'bulky-straight-3-semi': {
          rects: [
            { x: 0, y: 0, w: 56, h: 55 },
            { x: 58, y: 0, w: 48, h: 55 },
            { x: 108, y: 0, w: 56, h: 55 },
            { x: 108, y: 63, w: 50, h: 28, isSemiCircle: true }
          ],
          vw: 164, vh: 91
        },
        'bulky-l-90-open': {
          rects: [
            { x: 0, y: 0, w: 56, h: 55 },
            { x: 58, y: 0, w: 48, h: 55 },
            { x: 58, y: 57, w: 62, h: 62 },
            { x: 122, y: 57, w: 48, h: 62 }
          ],
          vw: 170, vh: 119
        },
        'bulky-l-90-open-foot': {
          rects: [
            { x: 0, y: 0, w: 56, h: 55 },
            { x: 58, y: 0, w: 48, h: 55 },
            { x: 58, y: 57, w: 62, h: 62 },
            { x: 122, y: 57, w: 48, h: 62 },
            { x: 122, y: 127, w: 42, h: 30, isFootstool: true }
          ],
          vw: 170, vh: 157
        },
        'bulky-l-90-open-semi': {
          rects: [
            { x: 0, y: 0, w: 56, h: 55 },
            { x: 58, y: 0, w: 48, h: 55 },
            { x: 58, y: 57, w: 62, h: 62 },
            { x: 122, y: 57, w: 48, h: 62 },
            { x: 122, y: 127, w: 50, h: 28, isSemiCircle: true }
          ],
          vw: 172, vh: 155
        }
      },
      customModules: [
        { type: 'End Seater Left',       label: 'End Seater L',       isCorner: false, isFootstool: false, isEnd: true },
        { type: 'End Seater Right',      label: 'End Seater R',       isCorner: false, isFootstool: false, isEnd: true },
        { type: '1 Seater',              label: '1 Seater',           isCorner: false, isFootstool: false },
        { type: '45\u00b0 Round Corner', label: '45\u00b0 Corner',    isCorner: true,  isFootstool: false },
        { type: '90\u00b0 Round Corner', label: '90\u00b0 Round Corner', isCorner: true, isFootstool: false },
        { type: 'Footstool',             label: 'Footstool',          isCorner: false, isFootstool: true },
        { type: 'Semi-Circle Footstool', label: 'Semi-Circle',        isCorner: false, isFootstool: true, isSemiCircle: true }
      ],
      hasCornerTypeToggle: false,
      hasOrientationToggle: true,
      singleColor: true
    }
  };

  /* ---------- Utilities ---------- */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    var dollars = cents / 100;
    var amount = dollars.toFixed(2);
    var amountWithComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amountNoDecimals = Math.round(dollars).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (!format || format === '') format = '${{amount}}';
    return format
      .replace('{{amount_with_comma_separator}}', amountWithComma.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals.replace(',', '.'))
      .replace('{{amount}}', amountWithComma)
      .replace('{{amount_no_decimals}}', amountNoDecimals);
  }

  function renderSVG(shapeKey, shapeDefs, options) {
    options = options || {};
    var shape = shapeDefs[shapeKey];
    if (!shape) return '';
    var pad = 8;
    var vw = shape.vw + pad * 2;
    var vh = shape.vh + pad * 2;
    var mirrored = options.mirrored === true;
    var fill = '#e0d8cc';
    var stroke = '#b5a898';
    var els = shape.rects.map(function(r) {
      var rx = r.x + pad;
      var ry = r.y + pad;

      // Semi-circle footstool — half-circle arc below
      if (r.isSemiCircle) {
        var hw = r.w / 2;
        var d = 'M ' + rx + ',' + ry + ' A ' + hw + ',' + r.h + ' 0 0,1 ' + (rx + r.w) + ',' + ry + ' Z';
        return '<path d="' + d + '" fill="none" stroke="' + stroke + '" stroke-width="1" stroke-dasharray="3 2"/>';
      }

      // Footstool — dashed outline
      if (r.isFootstool) {
        return '<rect x="' + rx + '" y="' + ry + '" width="' + r.w + '" height="' + r.h + '" rx="2" fill="none" stroke="' + stroke + '" stroke-width="1" stroke-dasharray="3 2"/>';
      }

      // All sofa modules — filled rectangles
      return '<rect x="' + rx + '" y="' + ry + '" width="' + r.w + '" height="' + r.h + '" rx="3" fill="' + fill + '" stroke="' + stroke + '" stroke-width="1"/>';
    }).join('');
    var mirror = mirrored ? ' style="transform:scaleX(-1);transform-origin:center"' : '';
    return '<svg viewBox="0 0 ' + vw + ' ' + vh + '" xmlns="http://www.w3.org/2000/svg"' + mirror + '>' + els + '</svg>';
  }

  var ARROW_RIGHT = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';

  /* ---------- Main Constructor ---------- */

  function ModularConfigurator(sectionId) {
    this.sectionId = sectionId;
    this.data = window.__MODULAR_CONFIGURATOR__[sectionId];
    if (!this.data) return;
    this.container = document.getElementById('ModularConfigurator-' + sectionId);
    if (!this.container) return;

    this.cfg = CONFIGS[this.data.configKey];
    if (!this.cfg) return;

    this.selectedColor = null;
    this.orientation = 'left';
    this.mode = 'preset';
    this.customModules = [];
    this.customIdCounter = 0;

    // Auto-select color in single-color mode
    if (this.cfg.singleColor && this.cfg.colorCategories.length) {
      this.selectedColor = this.cfg.colorCategories[0].colors[0];
    }

    this.init();
  }

  ModularConfigurator.prototype.init = function() {
    this.renderModeToggle();
    this.renderSwatches();
    this.renderPresets();
    this.bindGallery();

    // Auto-select color in single-color mode
    if (this.selectedColor) {
      this.container.querySelectorAll('.mc__swatch').forEach(function(btn) {
        btn.classList.toggle('is-selected', btn.dataset.color === this.selectedColor);
      }.bind(this));
      var nameEl = document.getElementById('MCColorName-' + this.sectionId);
      if (nameEl) nameEl.textContent = this.selectedColor;
    }

    if (this.cfg.singleColor) {
      this.container.classList.add('mc--single-color');
    }
  };

  /* ---------- Gallery ---------- */

  ModularConfigurator.prototype.bindGallery = function() {
    var thumbContainer = this.container.querySelector('.mc__gallery-thumbs');
    if (!thumbContainer) return;
    this.bindThumbClicks(thumbContainer);
  };

  ModularConfigurator.prototype.bindThumbClicks = function(thumbContainer) {
    var mainImg = document.getElementById('MCGalleryMain-' + this.sectionId);
    if (!mainImg || !thumbContainer) return;
    thumbContainer.querySelectorAll('.mc__gallery-thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        mainImg.src = thumb.dataset.fullUrl;
        thumbContainer.querySelectorAll('.mc__gallery-thumb').forEach(function(t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  };

  ModularConfigurator.prototype.updateGallery = function() {
    var mainImg = document.getElementById('MCGalleryMain-' + this.sectionId);
    var thumbContainer = this.container.querySelector('.mc__gallery-thumbs');
    if (!mainImg || !thumbContainer) return;
    var images = this.data.productImages || [];
    if (!images.length) return;

    var color = this.selectedColor;
    if (!color) return;

    var colorLower = color.toLowerCase();
    var filtered = images.filter(function(img) {
      return (img.alt || '').toLowerCase().indexOf(colorLower) !== -1;
    });

    if (!filtered.length) filtered = images;
    var thumbImages = filtered.slice(0, 20);
    mainImg.src = thumbImages[0].url;

    var html = '';
    thumbImages.forEach(function(img, i) {
      var activeClass = i === 0 ? ' is-active' : '';
      html += '<button class="mc__gallery-thumb' + activeClass + '"';
      html += ' data-full-url="' + img.url + '"';
      html += ' type="button" aria-label="View image ' + (i + 1) + '">';
      html += '<img src="' + img.thumb + '" alt="' + (img.alt || '').replace(/"/g, '&quot;') + '" width="120" height="120" loading="lazy">';
      html += '</button>';
    });
    thumbContainer.innerHTML = html;
    this.bindThumbClicks(thumbContainer);
  };

  /* ---------- Swatches ---------- */

  ModularConfigurator.prototype.renderSwatches = function() {
    var self = this;
    var container = document.getElementById('MCSwatches-' + this.sectionId);
    if (!container) return;
    var cfg = this.cfg;
    var availableColors = {};
    this.data.variants.forEach(function(v) {
      if (!availableColors[v.color]) availableColors[v.color] = true;
    });

    var html = '';
    cfg.colorCategories.forEach(function(cat, catIdx) {
      var hasColors = cat.colors.some(function(c) { return availableColors[c]; });
      if (!hasColors) return;
      if (catIdx > 0) html += '<div class="mc__swatch-divider"></div>';
      html += '<div class="mc__swatch-group">';
      html += '<div class="mc__swatch-group-label">' + cat.label + '</div>';
      html += '<div class="mc__swatch-group-colors">';
      cat.colors.forEach(function(color) {
        if (!availableColors[color]) return;
        var hex = cfg.colorHex[color] || '#ccc';
        html += '<button class="mc__swatch' + (self.selectedColor === color ? ' is-selected' : '') + '" data-color="' + color + '" type="button" aria-label="' + color + '" title="' + color + '">';
        html += '<span class="mc__swatch-circle" style="background-color: ' + hex + ';"></span>';
        html += '<span class="mc__swatch-name">' + color + '</span>';
        html += '</button>';
      });
      html += '</div></div>';
    });

    container.innerHTML = html;
    container.querySelectorAll('.mc__swatch').forEach(function(btn) {
      btn.addEventListener('click', function() { self.selectColor(btn.dataset.color); });
    });
  };

  ModularConfigurator.prototype.selectColor = function(color) {
    this.selectedColor = color;
    this.container.querySelectorAll('.mc__swatch').forEach(function(btn) {
      btn.classList.toggle('is-selected', btn.dataset.color === color);
    });
    var nameEl = document.getElementById('MCColorName-' + this.sectionId);
    if (nameEl) nameEl.textContent = color;
    if (this.mode === 'custom') {
      this.renderModulePalette();
      this.renderBuildStrip();
      this.validateCustomBuild();
    } else {
      this.renderPresets();
    }
    this.updateGallery();
    this.updateSummary();
  };

  /* ---------- Variant Lookup ---------- */

  ModularConfigurator.prototype.getVariant = function(color, module) {
    return this.data.variants.find(function(v) {
      return v.color === color && v.module === module;
    });
  };

  ModularConfigurator.prototype.getModulePrice = function(type) {
    var self = this;
    var color = this.selectedColor;
    if (color) {
      var v = this.getVariant(color, type);
      return v ? v.price : null;
    }
    var minPrice = null;
    this.data.variants.forEach(function(v) {
      if (v.module === type && (minPrice === null || v.price < minPrice)) minPrice = v.price;
    });
    return minPrice;
  };

  ModularConfigurator.prototype.calculatePresetPrice = function(preset, color) {
    var self = this;
    var c = color || this.selectedColor;
    if (!c) return null;
    var total = 0, valid = true;
    preset.modules.forEach(function(mod) {
      var v = self.getVariant(c, mod);
      if (v) total += v.price; else valid = false;
    });
    return valid ? total : null;
  };

  ModularConfigurator.prototype.calculateFromPrice = function(preset) {
    var self = this;
    var allColors = [];
    this.data.variants.forEach(function(v) {
      if (allColors.indexOf(v.color) === -1) allColors.push(v.color);
    });
    var minPrice = null;
    allColors.forEach(function(color) {
      var price = self.calculatePresetPrice(preset, color);
      if (price !== null && (minPrice === null || price < minPrice)) minPrice = price;
    });
    return minPrice;
  };

  ModularConfigurator.prototype.isPresetAvailable = function(preset, color) {
    var self = this;
    var c = color || this.selectedColor;
    if (!c) return true;
    return preset.modules.every(function(mod) {
      var v = self.getVariant(c, mod);
      return v && v.available;
    });
  };

  /* ---------- Preset Mode ---------- */

  ModularConfigurator.prototype.renderPresets = function() {
    var self = this;
    var container = document.getElementById('MCLayouts-' + this.sectionId);
    if (!container) return;
    var cfg = this.cfg;
    var hasColor = !!this.selectedColor;
    var setProducts = this.data.setProducts || {};

    var html = '';
    cfg.presets.forEach(function(preset) {
      var unavailable = hasColor && !self.isPresetAvailable(preset);
      var classes = 'mc__layout-card';
      if (unavailable) classes += ' is-unavailable';

      var setData = setProducts[preset.setProductKey];

      html += '<div class="' + classes + '" data-preset-id="' + preset.id + '">';

      // Product image or SVG fallback
      if (setData && setData.image) {
        var mirrored = self.orientation === 'right' && preset.hasOrientation;
        html += '<div class="mc__layout-image' + (mirrored ? ' is-mirrored' : '') + '">';
        html += '<img src="' + setData.image + '" alt="' + preset.name + '" loading="lazy">';
        html += '</div>';
      } else {
        var mirrored = self.orientation === 'right' && preset.hasOrientation;
        html += '<div class="mc__svg-wrap">';
        html += renderSVG(preset.shapeKey, cfg.shapeDefs, { mirrored: mirrored });
        html += '</div>';
      }

      // Layout name
      html += '<div class="mc__layout-name">' + preset.name + '</div>';

      // Module count
      html += '<div class="mc__layout-modules">' + preset.modules.length + ' modules</div>';

      // CTA with price
      if (unavailable) {
        html += '<div class="mc__layout-cta mc__layout-cta--unavail">Unavailable</div>';
      } else if (setData && setData.url) {
        var priceStr = '';
        if (setData.price) {
          priceStr = formatMoney(setData.price, self.data.moneyFormat);
        }
        html += '<a href="' + setData.url + '" class="mc__layout-cta">';
        html += (priceStr ? '<span class="mc__layout-price">' + priceStr + '</span>' : '');
        html += '<span>View Set ' + ARROW_RIGHT + '</span>';
        html += '</a>';
      } else {
        var price = hasColor ? self.calculatePresetPrice(preset) : self.calculateFromPrice(preset);
        if (price !== null) {
          html += '<div class="mc__layout-cta">';
          html += (hasColor ? '' : 'From ') + '<span class="mc__layout-price">' + formatMoney(price, self.data.moneyFormat) + '</span>';
          html += '</div>';
        }
      }

      html += '</div>';
    });

    container.innerHTML = html;
  };

  /* ---------- Mode Toggle ---------- */

  ModularConfigurator.prototype.renderModeToggle = function() {
    var self = this;
    var el = document.getElementById('MCModeToggle-' + this.sectionId);
    if (!el) return;
    var html = '<div class="mc__mode-tabs">';
    html += '<button class="mc__mode-tab' + (this.mode === 'preset' ? ' is-active' : '') + '" data-mode="preset" type="button">Choose a Layout</button>';
    html += '<button class="mc__mode-tab' + (this.mode === 'custom' ? ' is-active' : '') + '" data-mode="custom" type="button">Build Your Own</button>';
    html += '</div>';
    el.innerHTML = html;
    el.querySelectorAll('.mc__mode-tab').forEach(function(btn) {
      btn.addEventListener('click', function() { self.setMode(btn.dataset.mode); });
    });
  };

  ModularConfigurator.prototype.setMode = function(mode) {
    if (this.mode === mode) return;
    this.mode = mode;
    var layoutsEl = document.getElementById('MCLayouts-' + this.sectionId);
    var customEl = document.getElementById('MCCustomBuilder-' + this.sectionId);
    var optionsEl = document.getElementById('MCOptions-' + this.sectionId);
    if (mode === 'custom') {
      if (layoutsEl) layoutsEl.style.display = 'none';
      if (optionsEl) optionsEl.style.display = 'none';
      if (customEl) { customEl.style.display = ''; this.renderCustomBuilder(); }
    } else {
      if (layoutsEl) layoutsEl.style.display = '';
      if (customEl) customEl.style.display = 'none';
      this.renderPresetOptions();
      this.renderPresets();
    }
    this.renderModeToggle();
    this.updateSummary();
  };

  /* ---------- Preset Options (Orientation) ---------- */

  ModularConfigurator.prototype.renderPresetOptions = function() {
    var optionsEl = document.getElementById('MCOptions-' + this.sectionId);
    if (!optionsEl) return;
    var cfg = this.cfg;

    if (!cfg.hasOrientationToggle) {
      optionsEl.style.display = 'none';
      return;
    }

    optionsEl.style.display = '';
    var self = this;
    var html = '';

    // Orientation toggle
    html += '<div class="mc__option-group">';
    html += '<span class="mc__option-label">Orientation (for L-shapes)</span>';
    html += '<div class="mc__option-toggle">';

    html += '<button class="mc__option-btn' + (this.orientation === 'left' ? ' is-active' : '') + '" data-orientation="left" type="button">';
    html += 'Left-Facing</button>';
    html += '<button class="mc__option-btn' + (this.orientation === 'right' ? ' is-active' : '') + '" data-orientation="right" type="button">';
    html += 'Right-Facing</button>';
    html += '</div></div>';

    optionsEl.innerHTML = html;

    optionsEl.querySelectorAll('[data-orientation]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        self.orientation = btn.dataset.orientation;
        self.renderPresetOptions();
        self.renderPresets();
        self.updateSummary();
      });
    });
  };

  /* ---------- Custom Builder ---------- */

  ModularConfigurator.prototype.renderCustomBuilder = function() {
    var el = document.getElementById('MCCustomBuilder-' + this.sectionId);
    if (!el) return;
    var html = '';
    html += '<div class="mc__palette" id="MCPalette-' + this.sectionId + '"></div>';
    html += '<div class="mc__strip" id="MCBuildStrip-' + this.sectionId + '"></div>';
    /* Preview removed — list-only mode */
    html += '<div class="mc__warnings" id="MCCustomWarnings-' + this.sectionId + '"></div>';
    el.innerHTML = html;
    this.renderModulePalette();
    this.renderBuildStrip();
    this.renderCustomPreview();
    this.validateCustomBuild();
  };

  ModularConfigurator.prototype.renderModuleMiniSVG = function(type) {
    var pad = 4;
    if (type === 'End Seater Left') return '<svg viewBox="0 0 52 44" xmlns="http://www.w3.org/2000/svg"><rect x="' + (pad + 6) + '" y="' + pad + '" width="38" height="36" rx="3" fill="none" stroke="#333" stroke-width="1.5"/><rect x="' + pad + '" y="' + (pad + 2) + '" width="6" height="32" rx="2" fill="#333" opacity="0.25" stroke="#333" stroke-width="1.2"/></svg>';
    if (type === 'End Seater Right') return '<svg viewBox="0 0 52 44" xmlns="http://www.w3.org/2000/svg"><rect x="' + pad + '" y="' + pad + '" width="38" height="36" rx="3" fill="none" stroke="#333" stroke-width="1.5"/><rect x="' + (pad + 38) + '" y="' + (pad + 2) + '" width="6" height="32" rx="2" fill="#333" opacity="0.25" stroke="#333" stroke-width="1.2"/></svg>';
    if (type === '1 Seater') return '<svg viewBox="0 0 48 44" xmlns="http://www.w3.org/2000/svg"><rect x="' + pad + '" y="' + pad + '" width="40" height="36" rx="3" fill="none" stroke="#333" stroke-width="1.5"/></svg>';
    if (type === 'Corner') return '<svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg"><rect x="' + pad + '" y="' + pad + '" width="44" height="44" rx="3" fill="none" stroke="#333" stroke-width="1.5"/></svg>';
    if (type === '45\u00b0 Round Corner') {
      var x = pad, y = pad, w = 44, h = 44;
      var d = 'M ' + x + ',' + y + ' L ' + (x + w) + ',' + y + ' A ' + (w * 2) + ',' + (h * 2) + ' 0 0,1 ' + x + ',' + (y + h) + ' Z';
      return '<svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg"><path d="' + d + '" fill="none" stroke="#333" stroke-width="1.5"/></svg>';
    }
    if (type === '90\u00b0 Round Corner') {
      var x = pad, y = pad, w = 44, h = 44;
      var d = 'M ' + x + ',' + y + ' L ' + (x + w) + ',' + y + ' A ' + w + ',' + h + ' 0 0,1 ' + x + ',' + (y + h) + ' Z';
      return '<svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg"><path d="' + d + '" fill="none" stroke="#333" stroke-width="1.5"/></svg>';
    }
    if (type === 'Footstool' || type === 'Ottoman') return '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><rect x="' + pad + '" y="' + pad + '" width="36" height="36" rx="2" fill="none" stroke="#333" stroke-width="1.5" stroke-dasharray="4 2"/></svg>';
    if (type === 'Semi-Circle Footstool') {
      var cr = 18;
      var cx = pad + cr;
      var d = 'M ' + pad + ',' + (pad + cr) + ' A ' + cr + ',' + cr + ' 0 0,1 ' + (pad + cr * 2) + ',' + (pad + cr) + ' L ' + pad + ',' + (pad + cr) + ' Z';
      return '<svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><path d="' + d + '" fill="none" stroke="#333" stroke-width="1.5" stroke-dasharray="4 2"/></svg>';
    }
    return '';
  };

  ModularConfigurator.prototype.renderModulePalette = function() {
    var self = this;
    var el = document.getElementById('MCPalette-' + this.sectionId);
    if (!el) return;
    var cfg = this.cfg;
    var hasColor = !!this.selectedColor;
    var cornerCount = this.customModules.filter(function(m) { return m.type.indexOf('Corner') !== -1; }).length;
    var footstoolCount = this.customModules.filter(function(m) {
      return m.type === 'Footstool' || m.type === 'Semi-Circle Footstool' || m.type === 'Ottoman';
    }).length;
    var atMax = this.customModules.length >= 8;

    var html = '<div class="mc__palette-grid">';
    cfg.customModules.forEach(function(mod) {
      var price = self.getModulePrice(mod.type);
      var disabled = atMax || (mod.isCorner && cornerCount >= 2) || (mod.isFootstool && footstoolCount >= 1);
      var cls = 'mc__palette-card' + (disabled ? ' is-disabled' : '');

      html += '<div class="' + cls + '" data-module-type="' + mod.type + '">';
      html += '<div class="mc__palette-svg">' + self.renderModuleMiniSVG(mod.type) + '</div>';
      html += '<div class="mc__palette-label">' + mod.label + '</div>';
      if (price !== null) {
        html += '<div class="mc__palette-price">' + (hasColor ? '' : 'From ') + formatMoney(price, self.data.moneyFormat) + '</div>';
      }
      html += '<button class="mc__palette-add" data-type="' + mod.type + '" type="button"' + (disabled ? ' disabled' : '') + '>+ Add</button>';
      html += '</div>';
    });
    html += '</div>';
    el.innerHTML = html;

    el.querySelectorAll('.mc__palette-add').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (!btn.disabled) self.addCustomModule(btn.dataset.type);
      });
    });
    el.querySelectorAll('.mc__palette-card').forEach(function(card) {
      card.addEventListener('click', function(e) {
        if (e.target.closest('.mc__palette-add')) return;
        var type = card.dataset.moduleType;
        self.showModuleImage(type);
      });
      card.style.cursor = 'pointer';
    });
  };

  ModularConfigurator.prototype.showModuleImage = function(moduleType) {
    var color = this.selectedColor;
    if (!color) return;
    var variant = this.getVariant(color, moduleType);
    if (!variant || !variant.image) return;
    var mainImg = document.getElementById('MCGalleryMain-' + this.sectionId);
    if (mainImg) {
      mainImg.src = variant.image;
      mainImg.alt = moduleType;
    }
  };

  /* ---------- Custom Builder: Build Strip ---------- */

  ModularConfigurator.prototype.addCustomModule = function(type) {
    if (this.customModules.length >= 8) return;
    this.customIdCounter++;
    this.customModules.push({ id: 'mod-' + this.customIdCounter, type: type });
    this.onCustomChange();
  };

  ModularConfigurator.prototype.removeCustomModule = function(id) {
    this.customModules = this.customModules.filter(function(m) { return m.id !== id; });
    this.onCustomChange();
  };

  ModularConfigurator.prototype.moveCustomModule = function(id, dir) {
    var idx = -1;
    for (var i = 0; i < this.customModules.length; i++) { if (this.customModules[i].id === id) { idx = i; break; } }
    if (idx === -1) return;
    var targetIdx = idx + dir;
    if (targetIdx < 0 || targetIdx >= this.customModules.length) return;
    var temp = this.customModules[idx];
    this.customModules[idx] = this.customModules[targetIdx];
    this.customModules[targetIdx] = temp;
    this.onCustomChange();
  };

  ModularConfigurator.prototype.onCustomChange = function() {
    this.renderModulePalette();
    this.renderBuildStrip();
    this.renderCustomPreview();
    this.validateCustomBuild();
    this.updateGallery();
    this.updateSummary();
  };

  ModularConfigurator.prototype.renderBuildStrip = function() {
    var self = this;
    var el = document.getElementById('MCBuildStrip-' + this.sectionId);
    if (!el) return;
    var cfg = this.cfg;
    if (!this.customModules.length) {
      el.innerHTML = '<div class="mc__strip-empty">Click "+ Add" above to start building your sofa</div>';
      return;
    }
    var html = '<div class="mc__strip-label">Your Modules</div>';
    html += '<div class="mc__strip-list" id="MCStripList-' + this.sectionId + '">';
    this.customModules.forEach(function(mod, i) {
      var modDef = cfg.customModules.find(function(d) { return d.type === mod.type; });
      var label = modDef ? modDef.label : mod.type;
      var price = self.getModulePrice(mod.type);
      html += '<div class="mc__strip-item" data-id="' + mod.id + '" draggable="true">';
      html += '<span class="mc__strip-drag" aria-label="Drag to reorder"><svg width="12" height="12" viewBox="0 0 12 12"><circle cx="3" cy="2" r="1.2" fill="currentColor"/><circle cx="9" cy="2" r="1.2" fill="currentColor"/><circle cx="3" cy="6" r="1.2" fill="currentColor"/><circle cx="9" cy="6" r="1.2" fill="currentColor"/><circle cx="3" cy="10" r="1.2" fill="currentColor"/><circle cx="9" cy="10" r="1.2" fill="currentColor"/></svg></span>';
      html += '<span class="mc__strip-num">' + (i + 1) + '</span>';
      html += '<span class="mc__strip-name">' + label + '</span>';
      if (price !== null) html += '<span class="mc__strip-price">' + formatMoney(price, self.data.moneyFormat) + '</span>';
      html += '<button class="mc__strip-btn mc__strip-btn--remove" data-id="' + mod.id + '" type="button" aria-label="Remove">\u00D7</button>';
      html += '</div>';
    });
    html += '</div>';
    el.innerHTML = html;

    // Remove buttons
    el.querySelectorAll('.mc__strip-btn--remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        self.removeCustomModule(btn.dataset.id);
      });
    });

    // Drag-and-drop reordering
    var draggedId = null;
    var list = document.getElementById('MCStripList-' + self.sectionId);
    if (!list) return;
    var items = list.querySelectorAll('.mc__strip-item');

    items.forEach(function(item) {
      item.addEventListener('dragstart', function(e) {
        draggedId = item.dataset.id;
        item.classList.add('is-dragging');
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', item.dataset.id);
      });

      item.addEventListener('dragend', function() {
        draggedId = null;
        item.classList.remove('is-dragging');
        list.querySelectorAll('.is-drag-over').forEach(function(el) { el.classList.remove('is-drag-over'); });
      });

      item.addEventListener('dragover', function(e) {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        if (item.dataset.id !== draggedId) {
          list.querySelectorAll('.is-drag-over').forEach(function(el) { el.classList.remove('is-drag-over'); });
          item.classList.add('is-drag-over');
        }
      });

      item.addEventListener('dragleave', function() {
        item.classList.remove('is-drag-over');
      });

      item.addEventListener('drop', function(e) {
        e.preventDefault();
        item.classList.remove('is-drag-over');
        if (!draggedId || item.dataset.id === draggedId) return;
        var fromIdx = -1, toIdx = -1;
        for (var i = 0; i < self.customModules.length; i++) {
          if (self.customModules[i].id === draggedId) fromIdx = i;
          if (self.customModules[i].id === item.dataset.id) toIdx = i;
        }
        if (fromIdx === -1 || toIdx === -1) return;
        var moved = self.customModules.splice(fromIdx, 1)[0];
        self.customModules.splice(toIdx, 0, moved);
        self.onCustomChange();
      });
    });

    // Touch drag-and-drop fallback
    self._initTouchDrag(list);
  };

  ModularConfigurator.prototype._initTouchDrag = function(list) {
    var self = this;
    var dragItem = null;
    var placeholder = null;
    var startY = 0;
    var itemHeight = 0;

    list.addEventListener('touchstart', function(e) {
      var handle = e.target.closest('.mc__strip-drag');
      if (!handle) return;
      var item = handle.closest('.mc__strip-item');
      if (!item) return;
      e.preventDefault();
      dragItem = item;
      startY = e.touches[0].clientY;
      itemHeight = item.offsetHeight;
      item.classList.add('is-dragging');
    }, { passive: false });

    list.addEventListener('touchmove', function(e) {
      if (!dragItem) return;
      e.preventDefault();
      var touchY = e.touches[0].clientY;
      var diff = touchY - startY;
      dragItem.style.transform = 'translateY(' + diff + 'px)';
      dragItem.style.zIndex = '10';

      // Highlight drop target
      var items = list.querySelectorAll('.mc__strip-item');
      items.forEach(function(it) { if (it !== dragItem) it.classList.remove('is-drag-over'); });
      var elem = document.elementFromPoint(e.touches[0].clientX, touchY);
      if (elem) {
        var target = elem.closest('.mc__strip-item');
        if (target && target !== dragItem) target.classList.add('is-drag-over');
      }
    }, { passive: false });

    list.addEventListener('touchend', function(e) {
      if (!dragItem) return;
      var touch = e.changedTouches[0];
      var elem = document.elementFromPoint(touch.clientX, touch.clientY);
      var target = elem ? elem.closest('.mc__strip-item') : null;

      dragItem.classList.remove('is-dragging');
      dragItem.style.transform = '';
      dragItem.style.zIndex = '';
      list.querySelectorAll('.is-drag-over').forEach(function(el) { el.classList.remove('is-drag-over'); });

      if (target && target !== dragItem) {
        var fromId = dragItem.dataset.id;
        var toId = target.dataset.id;
        var fromIdx = -1, toIdx = -1;
        for (var i = 0; i < self.customModules.length; i++) {
          if (self.customModules[i].id === fromId) fromIdx = i;
          if (self.customModules[i].id === toId) toIdx = i;
        }
        if (fromIdx !== -1 && toIdx !== -1) {
          var moved = self.customModules.splice(fromIdx, 1)[0];
          self.customModules.splice(toIdx, 0, moved);
          self.onCustomChange();
        }
      }
      dragItem = null;
    });
  };

  /* ---------- Custom Builder: SVG Auto-Layout ---------- */

  ModularConfigurator.prototype.computeCustomSVGLayout = function() {
    var modules = this.customModules;
    if (!modules.length) return null;
    var cfg = this.cfg;

    var SCALE = {};
    var modDims = cfg.moduleDimensions;
    for (var key in modDims) {
      var d = modDims[key];
      SCALE[key] = { w: Math.round(d.w * 1.7), h: Math.round(d.d * 1.7) };
    }
    if (SCALE['End Seater Left']) SCALE['End Seater Left'] = { w: 65, h: 65 };
    if (SCALE['End Seater Right']) SCALE['End Seater Right'] = { w: 65, h: 65 };
    if (SCALE['1 Seater']) SCALE['1 Seater'] = { w: 55, h: 65 };
    if (SCALE['Corner']) SCALE['Corner'] = { w: 65, h: 65 };
    if (SCALE['45\u00b0 Round Corner']) SCALE['45\u00b0 Round Corner'] = { w: 65, h: 65 };
    if (SCALE['90\u00b0 Round Corner']) SCALE['90\u00b0 Round Corner'] = { w: 75, h: 75 };
    if (SCALE['Footstool']) SCALE['Footstool'] = { w: 50, h: 40 };
    if (SCALE['Ottoman']) SCALE['Ottoman'] = { w: 50, h: 40 };
    if (SCALE['Semi-Circle Footstool']) SCALE['Semi-Circle Footstool'] = { w: 60, h: 60 };

    var GAP = 6;
    var dirIdx = 0; // 0=RIGHT, 1=DOWN, 2=LEFT, 3=UP
    var cx = 0, cy = 0;
    var rects = [];
    var footstoolInfo = null;
    var lastRect = null;

    for (var i = 0; i < modules.length; i++) {
      var mod = modules[i];
      var s = SCALE[mod.type] || { w: 65, h: 65 };
      var isCorner = mod.type.indexOf('Corner') !== -1;
      var isFootstool = mod.type === 'Footstool' || mod.type === 'Semi-Circle Footstool' || mod.type === 'Ottoman';
      var is45 = mod.type === '45\u00b0 Round Corner';
      var isRound = mod.type === '90\u00b0 Round Corner';
      var isSemiCircle = mod.type === 'Semi-Circle Footstool';

      if (isFootstool) {
        footstoolInfo = { type: mod.type, s: s, isSemiCircle: isSemiCircle, dirIdx: dirIdx, lastRect: lastRect };
        continue;
      }

      var pw, ph;
      if (dirIdx === 1 || dirIdx === 3) { pw = s.h; ph = s.w; }
      else { pw = s.w; ph = s.h; }

      var px = cx, py = cy;
      if (dirIdx === 2) px = cx - pw;
      if (dirIdx === 3) py = cy - ph;

      var rect = { x: px, y: py, w: pw, h: ph, type: mod.type, isCorner: isCorner, isRound: isRound, is45: is45, dirIdx: dirIdx };
      rects.push(rect);
      lastRect = rect;

      if (isCorner) {
        // Clockwise turn: RIGHT→DOWN→LEFT→UP
        dirIdx = (dirIdx + 1) % 4;
        if (dirIdx === 0) { cx = px + pw + GAP; cy = py; }
        else if (dirIdx === 1) { cx = px; cy = py + ph + GAP; }
        else if (dirIdx === 2) { cx = px - GAP; cy = py; }
        else if (dirIdx === 3) { cx = px; cy = py - GAP; }
      } else {
        if (dirIdx === 0) { cx = px + pw + GAP; }
        else if (dirIdx === 1) { cy = py + ph + GAP; }
        else if (dirIdx === 2) { cx = px - GAP; }
        else if (dirIdx === 3) { cy = py - GAP; }
      }
    }

    // Place footstool outside the sofa bounding box to avoid overlap
    if (footstoolInfo && rects.length) {
      var bbMinX = Infinity, bbMinY = Infinity, bbMaxX = -Infinity, bbMaxY = -Infinity;
      rects.forEach(function(r) {
        if (r.x < bbMinX) bbMinX = r.x;
        if (r.y < bbMinY) bbMinY = r.y;
        if (r.x + r.w > bbMaxX) bbMaxX = r.x + r.w;
        if (r.y + r.h > bbMaxY) bbMaxY = r.y + r.h;
      });

      var lr = footstoolInfo.lastRect || rects[rects.length - 1];
      var fs = footstoolInfo.s;
      var fd = footstoolInfo.dirIdx;
      var fx, fy;

      // Place perpendicular to the current flow direction, outside bounding box
      if (fd === 0 || fd === 2) {
        // Horizontal flow: place below bounding box, aligned to last module
        fx = lr.x + Math.round((lr.w - fs.w) / 2);
        fy = bbMaxY + GAP;
      } else {
        // Vertical flow: place to the right of bounding box, aligned to last module
        fx = bbMaxX + GAP;
        fy = lr.y + Math.round((lr.h - fs.h) / 2);
      }

      rects.push({
        x: fx, y: fy, w: fs.w, h: fs.h,
        type: footstoolInfo.type,
        isFootstool: true,
        isSemiCircle: footstoolInfo.isSemiCircle
      });
    }

    // Normalize to (0,0) origin
    var minX = Infinity, minY = Infinity;
    rects.forEach(function(r) { if (r.x < minX) minX = r.x; if (r.y < minY) minY = r.y; });
    rects.forEach(function(r) { r.x -= minX; r.y -= minY; });

    var maxX = 0, maxY = 0;
    rects.forEach(function(r) { if (r.x + r.w > maxX) maxX = r.x + r.w; if (r.y + r.h > maxY) maxY = r.y + r.h; });

    return { rects: rects, vw: maxX, vh: maxY };
  };

  ModularConfigurator.prototype.renderCustomSVG = function(data) {
    if (!data || !data.rects.length) return '';
    var pad = 8;
    var vw = data.vw + pad * 2;
    var vh = data.vh + pad * 2;
    var els = data.rects.map(function(r) {
      var rx = r.x + pad;
      var ry = r.y + pad;

      // Semi-circle footstool
      if (r.isSemiCircle) {
        var cr = r.w / 2;
        var d = 'M ' + rx + ',' + (ry + cr) + ' A ' + cr + ',' + cr + ' 0 0,1 ' + (rx + r.w) + ',' + (ry + cr) + ' L ' + rx + ',' + (ry + cr) + ' Z';
        return '<path d="' + d + '" fill="none" stroke="#333" stroke-width="1.5" stroke-dasharray="4 2"/>';
      }

      // Corner shapes — arc direction depends on entry direction (dirIdx)
      if (r.isCorner && (r.is45 || r.isRound)) {
        var arcR = r.isRound ? 1 : 2; // arc radius multiplier (1x for 90°, 2x for 45°)
        var d, dir = r.dirIdx || 0;
        if (dir === 0) {
          // Entering from left, turning down: arc top-right to bottom-left
          d = 'M ' + rx + ',' + ry + ' L ' + (rx + r.w) + ',' + ry +
              ' A ' + (r.w * arcR) + ',' + (r.h * arcR) + ' 0 0,1 ' + rx + ',' + (ry + r.h) + ' Z';
        } else if (dir === 1) {
          // Entering from top, turning left: arc bottom-right to top-left
          d = 'M ' + (rx + r.w) + ',' + ry + ' L ' + (rx + r.w) + ',' + (ry + r.h) +
              ' A ' + (r.w * arcR) + ',' + (r.h * arcR) + ' 0 0,1 ' + rx + ',' + ry + ' Z';
        } else if (dir === 2) {
          // Entering from right, turning up: arc bottom-left to top-right
          d = 'M ' + (rx + r.w) + ',' + (ry + r.h) + ' L ' + rx + ',' + (ry + r.h) +
              ' A ' + (r.w * arcR) + ',' + (r.h * arcR) + ' 0 0,1 ' + (rx + r.w) + ',' + ry + ' Z';
        } else {
          // Entering from bottom, turning right: arc top-left to bottom-right
          d = 'M ' + rx + ',' + (ry + r.h) + ' L ' + rx + ',' + ry +
              ' A ' + (r.w * arcR) + ',' + (r.h * arcR) + ' 0 0,1 ' + (rx + r.w) + ',' + (ry + r.h) + ' Z';
        }
        return '<path d="' + d + '" fill="none" stroke="#333" stroke-width="1.5"/>';
      }

      var cr = r.isFootstool ? 2 : 3;
      var dash = r.isFootstool ? ' stroke-dasharray="4 2"' : '';
      var rectSvg = '<rect x="' + rx + '" y="' + ry + '" width="' + r.w + '" height="' + r.h + '" rx="' + cr + '" fill="none" stroke="#333" stroke-width="1.5"' + dash + '/>';

      // Draw arm indicator for End Seater modules
      if (r.type === 'End Seater Left' || r.type === 'End Seater Right') {
        var armW = 5, armInset = 3;
        var ax, ay, aw, ah;
        var dir = r.dirIdx || 0;
        // End Seater Left: arm on trailing edge; End Seater Right: arm on leading edge
        var isLeft = r.type === 'End Seater Left';
        if (dir === 0) {
          // Going right: left arm = left edge, right arm = right edge
          ax = isLeft ? rx : rx + r.w - armW;
          ay = ry + armInset; aw = armW; ah = r.h - armInset * 2;
        } else if (dir === 1) {
          // Going down: left arm = top edge, right arm = bottom edge
          ax = rx + armInset; ay = isLeft ? ry : ry + r.h - armW;
          aw = r.w - armInset * 2; ah = armW;
        } else if (dir === 2) {
          // Going left: left arm = right edge, right arm = left edge
          ax = isLeft ? rx + r.w - armW : rx;
          ay = ry + armInset; aw = armW; ah = r.h - armInset * 2;
        } else {
          // Going up: left arm = bottom edge, right arm = top edge
          ax = rx + armInset; ay = isLeft ? ry + r.h - armW : ry;
          aw = r.w - armInset * 2; ah = armW;
        }
        rectSvg += '<rect x="' + ax + '" y="' + ay + '" width="' + aw + '" height="' + ah + '" rx="1.5" fill="#333" opacity="0.25" stroke="#333" stroke-width="0.8"/>';
      }

      return rectSvg;
    }).join('');
    return '<svg viewBox="0 0 ' + vw + ' ' + vh + '" xmlns="http://www.w3.org/2000/svg">' + els + '</svg>';
  };

  ModularConfigurator.prototype.renderCustomPreview = function() {
    return; // Preview removed — list-only mode
    var el = document.getElementById('MCCustomPreview-' + this.sectionId);
    if (!el) return;
    if (!this.customModules.length) { el.innerHTML = ''; return; }
    var data = this.computeCustomSVGLayout();
    if (!data) { el.innerHTML = ''; return; }
    el.innerHTML = '<div class="mc__preview-inner">' + this.renderCustomSVG(data) + '</div>';
  };

  /* ---------- Custom Builder: Validation ---------- */

  ModularConfigurator.prototype.validateCustomBuild = function() {
    var el = document.getElementById('MCCustomWarnings-' + this.sectionId);
    if (!el) return;
    if (!this.customModules.length) { el.innerHTML = ''; return; }

    var warnings = [];
    var corners = this.customModules.filter(function(m) { return m.type.indexOf('Corner') !== -1; });
    var footstools = this.customModules.filter(function(m) { return m.type === 'Footstool' || m.type === 'Semi-Circle Footstool' || m.type === 'Ottoman'; });

    if (corners.length > 2) warnings.push('Maximum 2 corner pieces allowed.');
    if (footstools.length > 1) warnings.push('Maximum 1 footstool allowed.');
    if (this.customModules.length > 8) warnings.push('Maximum 8 modules total.');

    if (this.selectedColor) {
      var self = this;
      var unavailable = this.customModules.some(function(m) {
        var v = self.getVariant(self.selectedColor, m.type);
        return !v || !v.available;
      });
      if (unavailable) warnings.push('Selected color is unavailable for one or more modules.');
    }

    if (!warnings.length) { el.innerHTML = ''; return; }
    var html = '';
    warnings.forEach(function(w) {
      html += '<div class="mc__warning">';
      html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/></svg>';
      html += '<span>' + w + '</span></div>';
    });
    el.innerHTML = html;
  };

  /* ---------- Custom Builder: Synthetic Layout ---------- */

  ModularConfigurator.prototype.getCustomLayout = function() {
    if (!this.customModules.length) return null;
    var mods = this.customModules.map(function(m) { return m.type; });
    return {
      id: 'custom',
      name: 'Custom Build',
      modules: mods
    };
  };

  /* ---------- Footprint Calculation ---------- */

  ModularConfigurator.prototype.calculateFootprint = function(modules) {
    if (!modules || !modules.length) return null;
    var cfg = this.cfg;
    var dims = cfg.moduleDimensions;
    var dimsCm = cfg.moduleDimensionsCm;

    var corners = modules.filter(function(m) { return m.indexOf('Corner') !== -1; });

    if (corners.length === 0) {
      // Straight layout: sum widths
      var totalW = 0, totalD = 0, totalW_cm = 0, totalD_cm = 0;
      modules.forEach(function(mod) {
        var d = dims[mod], dc = dimsCm[mod];
        if (d) { totalW += d.w; totalD = Math.max(totalD, d.d); }
        if (dc) { totalW_cm += dc.w; totalD_cm = Math.max(totalD_cm, dc.d); }
      });
      totalW += Math.max(0, (modules.length - 1)) * 2;
      totalW_cm += Math.max(0, (modules.length - 1)) * 5;
      if (totalW === 0) return null;
      return { w_in: Math.round(totalW * 10) / 10, d_in: Math.round(totalD * 10) / 10, w_cm: Math.round(totalW_cm), d_cm: Math.round(totalD_cm) };
    }

    // L-shape: compute from corner position
    var firstCornerIdx = -1;
    for (var i = 0; i < modules.length; i++) {
      if (modules[i].indexOf('Corner') !== -1) { firstCornerIdx = i; break; }
    }
    var corner = modules[firstCornerIdx];
    var cDim = dims[corner] || { w: 40, d: 40 };
    var cDimCm = dimsCm[corner] || { w: 100, d: 100 };

    // Horizontal arm: corner + everything after
    var totalW = cDim.w, totalW_cm = cDimCm.w;
    for (var j = firstCornerIdx + 1; j < modules.length; j++) {
      if (modules[j] === 'Footstool' || modules[j] === 'Semi-Circle Footstool' || modules[j] === 'Ottoman') continue;
      var d = dims[modules[j]], dc = dimsCm[modules[j]];
      if (d) totalW += d.w + 2;
      if (dc) totalW_cm += dc.w + 5;
    }

    // Vertical arm: everything before corner
    var totalD = cDim.d, totalD_cm = cDimCm.d;
    for (var k = 0; k < firstCornerIdx; k++) {
      if (modules[k] === 'Footstool' || modules[k] === 'Semi-Circle Footstool' || modules[k] === 'Ottoman') continue;
      var d = dims[modules[k]], dc = dimsCm[modules[k]];
      if (d) totalD += d.d + 2;
      if (dc) totalD_cm += dc.d + 5;
    }

    // Footstool/ottoman/semi-circle adds depth
    var hasFootstool = modules.indexOf('Footstool') !== -1 || modules.indexOf('Semi-Circle Footstool') !== -1 || modules.indexOf('Ottoman') !== -1;
    if (hasFootstool) {
      var fsType = modules.indexOf('Semi-Circle Footstool') !== -1 ? 'Semi-Circle Footstool' : (modules.indexOf('Ottoman') !== -1 ? 'Ottoman' : 'Footstool');
      var fsDim = dims[fsType], fsDimCm = dimsCm[fsType];
      if (fsDim) totalD += fsDim.d + 4;
      if (fsDimCm) totalD_cm += fsDimCm.d + 10;
    }

    if (totalW === 0) return null;
    return { w_in: Math.round(totalW * 10) / 10, d_in: Math.round(totalD * 10) / 10, w_cm: Math.round(totalW_cm), d_cm: Math.round(totalD_cm) };
  };

  /* ---------- Summary ---------- */

  ModularConfigurator.prototype.updateSummary = function() {
    var summarySection = document.getElementById('MCStepSummary-' + this.sectionId);
    var summaryContainer = document.getElementById('MCSummary-' + this.sectionId);
    if (!summarySection || !summaryContainer) return;

    if (this.mode !== 'custom' || !this.customModules.length || !this.selectedColor) {
      summarySection.style.display = 'none';
      return;
    }

    var layout = this.getCustomLayout();
    if (!layout) { summarySection.style.display = 'none'; return; }

    summarySection.style.display = '';
    var self = this;
    var cfg = this.cfg;
    var colorHex = cfg.colorHex[this.selectedColor] || '#ccc';
    var totalPrice = 0;

    var modulesHtml = '';
    layout.modules.forEach(function(mod) {
      var variant = self.getVariant(self.selectedColor, mod);
      if (variant) {
        totalPrice += variant.price;
        modulesHtml += '<li class="mc__summary-module">';
        modulesHtml += '<span class="mc__summary-module-name">' + cfg.name.split(' ')[0] + ' ' + mod + '</span>';
        modulesHtml += '<span class="mc__summary-module-price">' + formatMoney(variant.price, self.data.moneyFormat) + '</span>';
        modulesHtml += '</li>';
      }
    });

    var html = '';

    html += '<div class="mc__summary-details">';

    // Color
    html += '<div class="mc__summary-color">';
    html += '<span class="mc__summary-color-circle" style="background-color: ' + colorHex + ';"></span>';
    html += '<span>' + this.selectedColor + '</span>';
    html += '</div>';

    // Layout label
    html += '<div class="mc__summary-layout-name">Custom Build \u00b7 ' + layout.modules.length + ' Modules</div>';

    // Footprint
    var footprint = this.calculateFootprint(layout.modules);
    if (footprint) {
      html += '<div class="mc__summary-dimensions">';
      html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 3H3v18"/></svg>';
      html += '<span>Total footprint: ' + footprint.w_in + '\u2033 W \u00d7 ' + footprint.d_in + '\u2033 D';
      html += ' <span class="mc__dims-cm">(' + footprint.w_cm + ' \u00d7 ' + footprint.d_cm + ' cm)</span></span></div>';
    }

    // Module breakdown
    html += '<ul class="mc__summary-modules">' + modulesHtml + '</ul>';

    // Total
    html += '<div class="mc__summary-total"><span>Total</span><span>' + formatMoney(totalPrice, this.data.moneyFormat) + '</span></div>';

    // Financing teaser
    var monthlyPayment = Math.round(totalPrice / 100 / 12);
    if (monthlyPayment > 0) {
      html += '<div class="mc__financing-teaser">As low as <strong>$' + monthlyPayment + '/mo</strong> with <span class="mc__shop-pay">Shop Pay Installments</span></div>';
    }

    // Add to Cart button
    html += '<button class="mc__add-to-cart" type="button" id="MCAddToCart-' + this.sectionId + '">Add Configuration to Cart</button>';

    // Trust bar
    html += '<div class="mc__trust-bar">';
    html += '<div class="mc__trust-item"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="6" width="22" height="13" rx="2"/><path d="M1 10h22"/></svg><span>Free Shipping Over $999</span></div>';
    html += '<div class="mc__trust-item"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg><span>5-Year Frame Warranty</span></div>';
    html += '<div class="mc__trust-item"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 10h4l3-7 3 7h4l-3.5 4 1.5 6-5-3.5L4.5 20l1.5-6L3 10z"/></svg><span>30-Day Returns</span></div>';
    html += '</div>';

    html += '</div>';

    summaryContainer.innerHTML = html;
    var addBtn = document.getElementById('MCAddToCart-' + this.sectionId);
    if (addBtn) addBtn.addEventListener('click', function() { self.addToCart(); });
  };

  /* ---------- Add to Cart ---------- */

  ModularConfigurator.prototype.addToCart = function() {
    var self = this;
    var layout = this.getCustomLayout();
    if (!layout || !this.selectedColor) return;

    var addBtn = document.getElementById('MCAddToCart-' + this.sectionId);
    if (addBtn) { addBtn.classList.add('is-loading'); addBtn.textContent = 'Adding to Cart\u2026'; addBtn.disabled = true; }

    var itemMap = {}, valid = true;
    layout.modules.forEach(function(mod) {
      var variant = self.getVariant(self.selectedColor, mod);
      if (!variant) { valid = false; return; }
      if (itemMap[variant.id]) itemMap[variant.id].quantity += 1;
      else itemMap[variant.id] = { id: variant.id, quantity: 1 };
    });

    if (!valid) {
      if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.textContent = 'Configuration unavailable'; addBtn.disabled = false; }
      return;
    }

    var items = Object.keys(itemMap).map(function(k) { return itemMap[k]; });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function(res) { if (!res.ok) throw new Error('Cart add failed'); return res.json(); })
    .then(function() { window.location.href = '/cart'; })
    .catch(function(err) {
      console.error('Modular configurator cart error:', err);
      if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.textContent = 'Error \u2014 Please Try Again'; addBtn.disabled = false;
        setTimeout(function() { addBtn.textContent = 'Add Configuration to Cart'; }, 3000);
      }
    });
  };

  /* ---------- Auto-initialize ---------- */

  function initAll() {
    document.querySelectorAll('.modular-configurator').forEach(function(el) {
      var sid = el.dataset.sectionId;
      if (sid && !el._mcInit) { el._mcInit = true; new ModularConfigurator(sid); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

})();
